<template>
  <div> <transition name="modal" v-if="carregando">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
            <label>Aguarde. Carregando.</label>
          </div>
        </div>
      </div>
    </transition>

    <div class="fora" v-else>
      <div class="topo-header centro">
        <botao-voltar class="voltar" tituloRota="Ocorrencia" />
        <h1>Visualizar Conteúdo</h1>
      </div>

      <div class="form centro">
        <div class="dados">
          <fieldset>
            <div class="dados">
              <div class="flexbox-1">
                <p>Autor: <span>{{ ocorrencia.usuario.nome }}</span></p>
                <p>Órgão: <span>{{ ocorrencia.orgao.nome }}</span></p>
                <p>N° da ocorrência: <span>{{ ocorrencia.id }}</span></p>
                <p>Título: <span>{{ ocorrencia.titulo }}</span></p>                
                  <p>
                    Status:
                    <v-select
                      v-if="podeAlterarStatus"
                      :value="ocorrenciaLocal.status"
                      :options="optionsStatus"
                      :reduce="option => option.value"
                      @input="novoStatus => abrirModalConfirmacaoStatus(ocorrenciaLocal, novoStatus)"
                      label="label"
                      class="dropdown-status-inline"
                      :clearable="false"
                      :searchable="false"
                      :selectable="option => isStatusSelectable(option, ocorrenciaLocal)"
                    />
                    <span v-else>
                      {{ formatarStatus(ocorrenciaLocal.status) }}
                    </span>
                  </p>
                <p>Tipo: <span>{{ formatarTipo(ocorrencia.tipo) }}</span></p>
                <p>Descrição: <span class="descricao">{{ ocorrencia.descricao }}</span></p>
                <p>Anexo:
                  <span v-if="!ocorrencia.anexo_url">Sem anexo</span>
                  <a v-else :href="this.urlAnexo" target="_blank">Visualizar Anexo</a>
                </p>
              </div>
            </div>
          </fieldset>
        </div>

        <div
          v-if="ocorrencia.status === 'aberto' && usuario_logado.id === ocorrencia.usuario_id"
          class="bt-editar">
          <a :href="'/ocorrencias/' + ocorrencia.id + '/edit'">
            <button id="botao-editar">Editar</button>
          </a>
        </div>
      </div>

      <div class="form centro" v-if="ocorrencia.status != 'aberto'">
        <h2>Comentários</h2>
        <div v-if="comentariosLocais.length" class="formulario-comentario">
          <div v-for="comentario in comentariosLocais" :key="comentario.id" class="comentario-item">
            <ExibirComentario :comentario="comentario" />
          </div>
        </div>
        <div v-else class="form centro sem-comentarios">
          <p>Não possui comentários.</p>
        </div>
        <div
          v-if="['aberto', 'em_andamento'].includes(ocorrencia.status) && usuario_logado.id === ocorrencia.usuario_id || temPermissao.admin"
          class="bt-editar"
        >
          <button id="botao-editar" @click="mostrarFormComentario = !mostrarFormComentario">
            {{ mostrarFormComentario ? "Cancelar" : "Adicionar Comentário" }}
          </button>
        </div>
        <transition name="fade">
          <div v-if="mostrarFormComentario" class="formulario-comentario">
            <ComentariosForm
              :comentario="null"
              :ocorrencia_id="ocorrencia.id"
              :key="'novo-comentario'"
              @comentario-criado="comentarioCriado"
            />
          </div>
        </transition>
      </div>
      <div class="secao-inferior centro">
        <BannerContato/>
        <Footer
          :mostrarFooter="temPermissao.admin"
          :createdByLabel="'Criado por'"
          :criadoPor="ocorrencia.criado_por"
          :lastUpdatedByLabel="'Última atualização feita por'"
          :atualizadoPor="ocorrencia.atualizado_por"
          :emLabel="' em '"
          :SistemaLabel="'Sistema'"
          :created_at="ocorrencia.created_at"
          :updated_at="ocorrencia.updated_at"
        />
      </div>
    </div>
    <div v-if="modalConfirmacaoStatusVisivel" class="modal-edit">
      <div class="modal-mask">
        <div class="modal-container">
          <div class="modal-header">
            <h2>Deseja mesmo alterar o status?</h2>
          </div>
          <div class="modal-body">
            <p><strong>Novo Status:</strong> {{ formatarStatus(novoStatusProposto) }}</p>
          </div>
          <div class="modal-footer">
            <button class="btn-confirmar-edicao" @click="confirmarMudancaStatus">Sim</button>
            <button class="btn-cancelar-edicao" @click="cancelarMudancaStatus">Não</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// Imports originais e novos
import BotaoVoltar from "../BotaoVoltar.vue";
import OcorrenciaApi from "../../services/OcorrenciaApi";
import { parseISO, format } from "date-fns";
import Footer from "../Footer.vue";
import ComentariosForm from "./ComentariosForm.vue";
import ExibirComentario from "./ExibirComentario.vue";
import ComentarioApi from "../../services/ComentarioApi";
import vSelect from "vue-select"; // Import necessário para o dropdown
import BannerContato from "./BannerContato.vue";

export default {
  name: "ExibirOcorrencia",
  props: {
    ocorrencia: Object,
    temPermissao: Object,
    usuario_logado: Object,
    comentarios: Array,
  },
  components: {
    // Seus componentes + o vSelect
    BotaoVoltar,
    Footer,
    ComentariosForm,
    ExibirComentario,
    vSelect,
    BannerContato,
  },
  data() {
    return {
      // Suas variáveis originais
      carregando: true,
      mostrarFormComentario: false,
      comentariosLocais: [],
      ocorrenciaAtualizada: null,

      // Variáveis para a nova funcionalidade de status
      ocorrenciaLocal: null, 
      modalConfirmacaoStatusVisivel: false,
      novoStatusProposto: null,
      statusOriginal: null,
      optionsStatus: [
        { label: "Aberto", value: "aberto" },
        { label: "Em Andamento", value: "em_andamento" },
        { label: "Finalizado", value: "finalizado" },
      ],
      urlAnexo: null,
    };
  },
  created() {
    this.OcorrenciaApi = new OcorrenciaApi();
    this.ComentarioApi = new ComentarioApi();
    this.carregando = false;
    this.urlAnexo = `${process.env.VUE_APP_BASE_API_URL}/api/v1/ocorrencias/${this.ocorrencia.id}/mostra_anexo`;
  },
  computed: {
    podeAlterarStatus() {
      return this.ocorrenciaLocal && (this.temPermissao.admin || this.temPermissao.gpd);
    },
  },
  methods: {
    // Seus métodos originais
    formatarDataHora(value) {
      return format(parseISO(value), "dd/MM/yyyy 'às' HH:mm:ss");
    },
    formatarStatus(valor) {
      const statusMap = {
        aberto: "Aberto",
        em_andamento: "Em Andamento",
        finalizado: "Finalizado",
      };
      return statusMap[valor] || valor;
    },
    formatarTipo(valor) {
      const tipoMap = {
        melhoria: "Sugestão",
        erro: "Reporte de Erro",
        duvida: "Dúvida",
        elogio: "Elogio",
        reclamacao: "Reclamação",
      };
      return tipoMap[valor] || valor;
    },
    comentarioCriado(novoComentario) {
      this.comentariosLocais.unshift(novoComentario);
      this.mostrarFormComentario = false;
      this.OcorrenciaApi.getOcorrencia(this.ocorrencia.id)
        .then((res) => {
          this.ocorrenciaAtualizada = res;
        })
        .catch((err) => {
          console.error("Erro ao atualizar dados da ocorrência:", err);
        });
    },

    // Novos métodos para alterar o status
    isStatusSelectable(option, ocorrencia) {
      const statusAtual = ocorrencia.status;
      const opcaoAlvo = option.value;
      const temComentarios = this.comentariosLocais && this.comentariosLocais.length > 0;

      if (statusAtual === 'em_andamento' && temComentarios && opcaoAlvo === 'aberto') {
        return false; // Não pode voltar para 'Aberto' se já tiver comentários
      }
      if (statusAtual === 'finalizado' && opcaoAlvo === 'aberto') {
        return false; // Não pode voltar para 'Aberto' de 'Finalizado'
      }
      return true;
    },
    abrirModalConfirmacaoStatus(ocorrencia, novoStatus) {
      if (ocorrencia.status === novoStatus) return;
      this.statusOriginal = ocorrencia.status;
      this.novoStatusProposto = novoStatus;
      this.modalConfirmacaoStatusVisivel = true;
    },
    cancelarMudancaStatus() {
      this.modalConfirmacaoStatusVisivel = false;
    },
    async confirmarMudancaStatus() {
      try {
        this.modalConfirmacaoStatusVisivel = false;
        await this.OcorrenciaApi.updateOcorrencia(this.ocorrenciaLocal.id, {
          status: this.novoStatusProposto,
        });
        this.ocorrenciaLocal.status = this.novoStatusProposto;
        this.$emit('ocorrencia-atualizada', this.ocorrenciaLocal);
        this.$root.$emit('ocorrenciasAtualizadas');
      } catch (error) {
        console.error("Erro ao atualizar o status:", error);
        alert("Não foi possível atualizar o status. Tente novamente.");
      }
    },
  },
  watch: {
    // Seus watches originais + o da ocorrência
    comentarios: {
      handler(novosComentarios) {
        this.comentariosLocais = [...novosComentarios];
      },
      immediate: true,
      deep: true,
    },
    ocorrencia: {
      handler(novaOcorrencia) {
        // Garante que a cópia local seja criada ou atualizada quando a prop for recebida
        if (novaOcorrencia && novaOcorrencia.id) {
          this.ocorrenciaLocal = JSON.parse(JSON.stringify(novaOcorrencia));
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">

.flexbox-1 {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem; /* Espaçamento entre os itens */
  

  p {
       grid-template-columns: auto !important; 
      }
}

/* Estilos adicionados para a nova funcionalidade */
.campo-detalhe {
  display: flex;
  align-items: center;
  gap: 10px; /* Espaço entre o <p> e o dropdown */
  margin-bottom: 1rem; // Adicionei margem para separar do próximo item
}

.campo-detalhe p {
  margin: 0; /* Remove margem padrão do parágrafo */
}

.dropdown-status-inline {
  display: inline-block; /* Permite que fique na mesma linha do texto */
  width: auto;
  max-width: 100%; /* Garante que não exceda o contêiner pai */
  vertical-align: middle; /* Alinha o dropdown com o texto "Status:" */
}

.descricao {
  word-break: break-word;
}

/* NOVOS ESTILOS PARA O MODAL (SUBSTITUA OS ANTERIORES)
*/
.modal-edit {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: table; /* Alterado para display: table */
  transition: opacity 0.3s ease;

    .modal-mask {
      border-radius: 1rem;
      position: relative;
      z-index: 1000;
      top: 20vh; /* Posiciona o modal 20% abaixo do topo da viewport */
      width: 90%; /* Largura padrão para telas menores */
      max-width: 500px; /* Largura máxima para telas maiores */
      height: auto;
      background-color: #f2f2f2;
      transition: opacity 0.3s ease;
      margin: 0 auto; /* Centraliza o modal horizontalmente */
    }
  .modal-container {
    height: 100%;
    padding: .7rem;
    position: relative;
    overflow-y: auto;
    overflow-x: auto;
    font-family: "Montserrat-Medium";
    align-content: center;

    .modal-header {
      height: fit-content;
      width: fit-content;
      margin: .5rem auto .3rem auto;

      h2 {
        font-size: 1.3rem;
        font-weight: bold;
      }
    }

    .modal-body {
      border: 1px solid gray;
      border-radius: 1rem;
      text-align: -webkit-center;

      p {
        font-size: 1rem;
        font-weight: bold;
        margin-top: .3rem;
        margin-bottom: .5rem;
        margin-left: 1rem;
        color: #005516;
      }

      .dados {
        font-weight: bold;
        font-size: 1rem;
        text-align-last: left;
        margin: 0 1rem .5rem 1rem;

        span {
          font-weight: normal;
          font-size: .9rem;
          margin-left: .3rem;
        }
      }
    }

    .modal-footer {
      margin: .7rem auto 0rem auto;
      place-content: space-evenly;
      font-size: 1rem;

      .btn-confirmar-edicao {
        border: none;
        border-radius: .5rem;
        width: 30%;
        height: 2.2rem;
        background-color: #005516;
        color: #f2f2f2;
      }

      .btn-confirmar-edicao:hover {
        background-color: #005517c2;
      }

      .btn-cancelar-edicao {
        border: none;
        border-radius: .5rem;
        width: 30%;
        height: 2.2rem;
        background-color: #bd0000;
        color: #f2f2f2;
      }

      .btn-cancelar-edicao:hover {
        background-color: #bd0000c4;
      }
    }
  }
}
</style>